import { Ability } from "@casl/ability";
import { AuthenticationApi, type AuthenticationApiInterface } from "bonusx-api-auth-manager";
import { useAtomValue, useSetAtom } from "jotai";
import { authApiConfig_v1 } from "../../constants/env";
import type { BonusXAbility } from "../interfaces/BonusXAbility";
import axiosInstance from "../services/axios-config-singleton/axios-config-singleton.instance";
import { AbilityRulesStore } from "../stores/abilityRulesStore";

export function useAbility(): BonusXAbility {
  const rules = useAtomValue(AbilityRulesStore);
  return new Ability(rules);
}

export function useAbilityRules() {
  const setAbility = useSetAtom(AbilityRulesStore);

  async function getAbilityRules(): Promise<object[]> {
    const authenticationApi: AuthenticationApiInterface = new AuthenticationApi(
      authApiConfig_v1,
      undefined,
      axiosInstance
    );
    const { data } = await authenticationApi.getAbilityRules();
    setAbility(data);
    return data;
  }

  return { getAbilityRules };
}
